import { get, isNil } from 'lodash-es';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';
import { MIN_MILE_VALUE } from 'site-modules/shared/utils/inventory/get-closest-range-value';

export const isRangeMapEligible = vehicle => {
  const isNewVehicle = isNew(get(vehicle, 'type'));
  const expectedRangeMin = get(vehicle, 'thirdPartyInfo.recurrentInsights.expectedRange.min');
  const epaRange = get(vehicle, 'vehicleInfo.partsInfo.electricityRange');
  const value = isNewVehicle ? epaRange : expectedRangeMin || epaRange;

  return !isNil(value) && value >= MIN_MILE_VALUE;
};
